import { render, staticRenderFns } from "./upload-button.vue?vue&type=template&id=901da576&scoped=true&"
import script from "./upload-button.vue?vue&type=script&lang=js&"
export * from "./upload-button.vue?vue&type=script&lang=js&"
import style0 from "./upload-button.vue?vue&type=style&index=0&id=901da576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901da576",
  null
  
)

export default component.exports